export const scrollIntoView = (el) => {
  el.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
    inline: 'center',
  });
};

export const scrollToSwoosh = () => scrollIntoView(document.querySelector('.c-header'));
